import styled from 'styled-components';

export const FeedbackWrapper = styled.div`
  margin-top: 16px;
  & > div:first-child {
    margin-bottom: 16px;
  }
`;

export const FeedbackElementWrapper = styled.div`
  display: flex;
  margin-bottom: 38px;
  & > div {
    margin-right: 48px;
  }
`;
